import styles from "./map-point-icon.module.scss";

const MapPointIcon = () => {
  return <div className={styles["marker"]} data-testid="marker-point"></div>;
};
export default MapPointIcon;
